// 引入组件
import footComponent from "components/content/Foot";


export default {
  	footComponent
}
